export default __webpack_public_path__ + "static/media/sfrxETH.77143d0f.png";